import { supportedLocales } from '$lib/i18n/index.js'

export const match = param => {
    return supportedLocales.includes(param)
}
